import { DateTime } from 'luxon';

/**
 * True when the trip's scheduled date equals `now`'s date in `now`'s zone.
 *
 * Gates "Activate will call" — activation overwrites the trip's pickup with
 * the dispatcher's "now", so opening the modal off-day silently shifts the
 * trip's date (BAM-164). Production callers omit `now`; `DateTime.now()`
 * resolves in the org tz (Luxon's default zone is pinned there at app boot).
 */
export function isWillCallScheduledForToday(
  scheduledPickupAt: string | null | undefined,
  now: DateTime = DateTime.now()
): boolean {
  if (!scheduledPickupAt) return false;
  return (
    DateTime.fromISO(scheduledPickupAt, { zone: now.zone }).toISODate() ===
    now.toISODate()
  );
}
